import {useTranslation} from '@app/hooks/use-translation';
import type {FunctionComponent} from 'react';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';

import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

const IMAGE_CONFIG: LocalImageConfig = {
	default: '94648fd2e6de6e4d2fe194d8c84d8756.png',
	fr: 'bbfa7c9f42c3607cd6472a0767009e1e.png',
};

export const LyricsSearch: FunctionComponent = () => {
	const {t} = useTranslation();
	const src = useLocalImage(IMAGE_CONFIG);

	return (
		<LandingIllustrationSection
			imagePosition="left"
			description={
				<>
					<LandingHeading as="h2">
						{t('lyricslandingpage_title_findsongbyitslyrics_standalone-web', {
							ns: 'lyrics',
						})}{' '}
					</LandingHeading>
					<LandingParagraph>
						{t('lyricslandingpage_text_findsongbyitslyrics_standalone-web', {
							ns: 'lyrics',
						})}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					aspectRatio="720/420"
					sizes={{base: '100vw', sm: '50vw'}}
					quality={65}
					h={{base: '300px', md: '100%'}}
					src={src}
					alt={t('metatag_text_sharelyricsonsocialmedia_standalone-web', {
						ns: 'common',
					})}
				/>
			}
		/>
	);
};
